// src/components/NavBar/useLinks.js
import { useEffect, useState } from "react";

export const useLinks = () => {
  const [linksData, setLinksData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch services
        const servicesResponse = await fetch("https://technow-overseasbackend.vercel.app/services");
        const services = await servicesResponse.json();

        // Fetch projects
        const projectsResponse = await fetch("https://technow-overseasbackend.vercel.app/projects");
        const projectsData = await projectsResponse.json();

        // Separate projects by status
        const ongoingProjects = projectsData.filter(p => p.status === "ongoing");
        const completedProjects = projectsData.filter(p => p.status === "completed");

        const linksStructure = [
          {
            name: "Area of Activities",
            submenu: true,
            link: "/services",
            sublinks: services.map(item => ({
              title: item.title,
              id: item.id,
            })),
          },
          {
            name: "Projects",
            submenu: true,
            link: "/projects",
            sublinks: [
              {
                title: "Ongoing",
                id: "ongoing",
                projects: ongoingProjects,
              },
              {
                title: "Completed",
                id: "completed",
                projects: completedProjects,
              },
            ],
          },
        ];

        setLinksData(linksStructure);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return { linksData, isLoading, error };
};
